<template>
  <div>
    <div class="grid grid-cols-2 gap-4 max-w-xl mt-2">
      <!-- PADDLE CLASSIC -->
      <div v-if="isClassic">
        <p class="text-sm font-semibold text-brand-black mb-2">Vendor ID</p>
        <el-input v-if="!editing && credentials.paddleVendorId" :value="credentials.paddleVendorId" type="text" disabled></el-input>
        <el-input v-else v-model="editingCredentials.paddleVendorId" type="text" @input="credentialsChanged"></el-input>
      </div>
      <div v-if="isClassic">
        <p class="text-sm font-semibold text-brand-black mb-2">Auth Code</p>
        <el-input
          v-if="!editing && credentials.paddleAuthCode"
          :value="credentials.paddleAuthCode.slice(0, 5) + '...'"
          type="text"
          disabled
        ></el-input>
        <el-input v-else v-model="editingCredentials.paddleAuthCode" type="text" @input="credentialsChanged"></el-input>
      </div>
      <div v-if="isClassic" class="col-span-2 brand-textarea">
        <p class="text-sm font-semibold text-brand-black mb-2">Public Key</p>
        <el-input
          v-if="!editing && credentials.paddlePublicKey"
          :value="credentials.paddlePublicKey.slice(0, 10) + '...'"
          type="textarea"
          disabled
        ></el-input>
        <el-input v-else v-model="editingCredentials.paddlePublicKey" type="textarea" @input="credentialsChanged"></el-input>
      </div>
      <!-- PADDLE BILLING -->
      <div v-if="!isClassic" class="col-span-2">
        <p class="text-sm font-semibold text-brand-black mb-2">API Key</p>
        <el-input
          v-if="!editing && credentials.paddleSecret"
          :value="credentials.paddleSecret.slice(0, 5) + '...'"
          type="text"
          disabled
        ></el-input>
        <el-input v-else v-model="editingCredentials.paddleSecret" type="text" @input="credentialsChanged"></el-input>
      </div>
      <div v-if="!isClassic" class="col-span-2">
        <p class="text-sm font-semibold text-brand-black mb-2">Webhook Secret</p>
        <el-input
          v-if="!editing && credentials.paddleWebhookSecret"
          :value="credentials.paddleWebhookSecret.slice(0, 5) + '...'"
          type="text"
          disabled
        ></el-input>
        <el-input v-else v-model="editingCredentials.paddleWebhookSecret" type="text" @input="credentialsChanged"></el-input>
      </div>
    </div>
    <div class="mt-4" v-if="!onboarding">
      <el-button v-if="hasAllcredentials && !editing" @click="startEditing()" type="primary">Edit</el-button>
      <el-button v-if="editing" @click="editing = false" type="text" class="focus:outline-none">Cancel</el-button>
      <el-button v-if="!hasAllcredentials || editing" @click="save" type="primary" :disabled="!setAllCredentials">Save</el-button>
      <el-button v-if="!editing && hasAllcredentials" @click="check" :loading="loading" type="default">
        {{ loading ? 'Verifying...' : 'Verify Connection' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PADDLE_VERSION } from '@/store/shared';

const EMPTY_CREDENTIALS = {
  paddleVendorId: '',
  paddleAuthCode: '',
  paddlePublicKey: '',
  paddleSecret: '',
  paddleWebhookSecret: '',
};

export default {
  props: {
    mode: {
      type: String,
      required: true,
    },
    version: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    credentials: {
      type: Object,
      required: true,
    },
    // Special version of this component used in onboarding Paddle connection
    onboarding: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      editing: !!this.onboarding,
      editingCredentials: this.onboarding ? { ...this.credentials } : { ...EMPTY_CREDENTIALS },
    };
  },
  computed: {
    ...mapGetters([
      // Add your getters here
    ]),
    isClassic() {
      return this.version === PADDLE_VERSION.CLASSIC;
    },
    newCredentials() {
      const credentials = this.credentials;
      const truthyEditingCredentials = Object.fromEntries(
        Object.entries(this.editingCredentials).filter(([key, value]) => value)
      );
      const mixedCredentials = { ...credentials, ...truthyEditingCredentials };
      return mixedCredentials;
    },
    setAllCredentials() {
      const newCredentials = this.newCredentials;
      const { paddleVendorId, paddleAuthCode, paddlePublicKey, paddleSecret, paddleWebhookSecret } = newCredentials;

      if (this.isClassic) {
        return !!paddleVendorId && !!paddleAuthCode && !!paddlePublicKey;
      }
      return !!paddleSecret && !!paddleWebhookSecret;
    },
    hasAllcredentials() {
      const { paddleVendorId, paddleAuthCode, paddlePublicKey, paddleSecret, paddleWebhookSecret } = this.credentials;
      if (this.isClassic) {
        return !!paddleVendorId && !!paddleAuthCode && !!paddlePublicKey;
      }
      return !!paddleSecret && !!paddleWebhookSecret;
    },
  },
  methods: {
    credentialsChanged() {
      if (this.onboarding) { // we could always do this, since we use a different method (update vs save)
        const newCredentials = this.newCredentials;
        this.$emit('update', { mode: this.mode, credentials: newCredentials });
      }
    },
    startEditing() {
      this.editingCredentials = { ...EMPTY_CREDENTIALS };
      this.editing = true;
    },
    save() {
      const newCredentials = this.newCredentials;
      this.$emit('save', { mode: this.mode, credentials: newCredentials });
      if (!this.onboarding) {
        this.editing = false;
      }
    },
    check() {
      this.$emit('check');
    },
  },
};
</script>
